// *****************************************************************************************************************
// * FORMAT FOR deadline: YYYY-MM-DDT18:00:00.000-04:00 FLORIDA TIMEZONE, EXAMPLE: "2023-05-30T18:00:00.000-04:00" *
// *****************************************************************************************************************

const ReactMainPage = props => {
  // const [live, setLive] = React.useState(true)

  // const checkTime = () => {
  //     const currentTime = new Date().toLocaleString("en-US", { timeZone: "America/New_York" });
  //     const time = Date.parse(new Date("2023-07-06T23:40:00.000-04:00").toLocaleString("en-US", { timeZone: "America/New_York" })) - Date.parse(currentTime);
  //     time < 0 ? setLive(false) : null
  // };

  // React.useEffect(() => {
  //     checkTime()

  // }, []);
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  React.useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);
    return _ => {
      window.removeEventListener('resize', handleResize);
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UnifiedBanner, {
    isVideo: true,
    type: "hero",
    deadline: "2025-12-25T00:00:00",
    currentDesktopSrc: "https://cdn.shopify.com/videos/c/o/v/6c8e19ac4efe45549b581c41f4ef609e.mp4",
    scheduledDesktopSrc: "https://cdn.shopify.com/videos/c/o/v/6c8e19ac4efe45549b581c41f4ef609e.mp4",
    currentMobileSrc: "https://cdn.shopify.com/videos/c/o/v/9c5e783458284207b36a0b5dbe38a2ee.mp4",
    scheduledMobileSrc: "https://cdn.shopify.com/videos/c/o/v/9c5e783458284207b36a0b5dbe38a2ee.mp4",
    currentDesktopPoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/preview_images/7088f317b59343848aa9b511913ea645.thumbnail.0000000000.jpg?v=1714755306",
    scheduledDesktopPoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/preview_images/7088f317b59343848aa9b511913ea645.thumbnail.0000000000.jpg?v=1714755306",
    currentMobilePoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/preview_images/502030b608e64495a0c38d9c969f46e6.thumbnail.0000000000.jpg?v=1714755334",
    scheduledMobilePoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/preview_images/502030b608e64495a0c38d9c969f46e6.thumbnail.0000000000.jpg?v=1714755334"
  }, /*#__PURE__*/React.createElement("div", {
    className: "unified-banner-caption"
  }, "WE ARE GYM TO STREET"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
    className: "unified-banner-buttons-container"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/pages/mens",
    className: "tlf-banner-buttons double-button padding-left"
  }, "SHOP MEN"), /*#__PURE__*/React.createElement("a", {
    href: "/pages/womens",
    className: "tlf-banner-buttons double-button"
  }, "SHOP WOMEN"))), /*#__PURE__*/React.createElement("div", {
    className: "miniDivider"
  }), /*#__PURE__*/React.createElement(UnifiedBanner, {
    isVideo: false,
    type: "slim",
    deadline: "2024-12-25T00:00:00",
    url: "https://tlfapparel.page.link/app",
    currentDesktopSrc: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0201_UnisexBanner_DownloadApp-15_Desktop.jpg?v=1706722645",
    scheduledDesktopSrc: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0201_UnisexBanner_DownloadApp-15_Desktop.jpg?v=1706722645",
    currentMobileSrc: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0201_UnisexBanner_DownloadApp-15_Mobile.jpg?v=1706722644",
    scheduledMobileSrc: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0201_UnisexBanner_DownloadApp-15_Mobile.jpg?v=1706722644",
    currentDesktopPoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0201_UnisexBanner_DownloadApp-15_Desktop.jpg?v=1706722645",
    scheduledDesktopPoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0201_UnisexBanner_DownloadApp-15_Desktop.jpg?v=1706722645",
    currentMobilePoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0201_UnisexBanner_DownloadApp-15_Mobile.jpg?v=1706722644",
    scheduledMobilePoster: "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0201_UnisexBanner_DownloadApp-15_Mobile.jpg?v=1706722644"
  }), /*#__PURE__*/React.createElement(PopUp, null));
};
if (document.getElementById('mainPage')) {
  const domContainerForReactMainPage = document.getElementById('mainPage');
  const rootForReactMainPage = ReactDOM.createRoot(domContainerForReactMainPage);
  rootForReactMainPage.render( /*#__PURE__*/React.createElement(ReactMainPage, null));
}
